module.exports = __webpack_public_path__ + "img/Background.8b9ae521.svg";